import { Anchor, Text } from '@mantine/core';
import { IconLink } from '@tabler/icons-react';
import { createPayoutTradersUrl } from '~/entities/payout';
import { type CascadeTrader } from '../types';
import { getTraderFilterValue, getTraderKey, getTraderLabel, handleCascadePathLinkClick } from '../utils';
import styles from '../CascadeEvents.module.css';
import { TextList } from './TextList';

interface TraderLinksProps {
    traders?: CascadeTrader[];
}

export const TraderLinks = ({ traders }: TraderLinksProps) => {
    if (!traders?.length) {
        return <TextList />;
    }

    return (
        <Text
            component='span'
            size='sm'
        >
            {traders.map((trader, index) => {
                const filterValue = getTraderFilterValue(trader);
                const label = getTraderLabel(trader);
                const separator = index < traders.length - 1 ? ', ' : '';

                if (!filterValue) {
                    return (
                        <span key={getTraderKey(trader)}>
                            {label}
                            {separator}
                        </span>
                    );
                }

                return (
                    <span key={getTraderKey(trader)}>
                        <Anchor
                            href={createPayoutTradersUrl({ traderName: filterValue })}
                            c='blue.6'
                            onClick={handleCascadePathLinkClick}
                            className={styles.inlineLink}
                        >
                            {label}
                            <IconLink size={14} />
                        </Anchor>
                        {separator}
                    </span>
                );
            })}
        </Text>
    );
};
